export default "__VITE_ASSET__UmGSJWWH__"